{
  "name": "ponderosametalworks-admin",
  "version": "1.0.14",
  "private": true,
  "scripts": {
    "start": "ng serve",
    "build": "ng build --configuration development",
    "build:prod": "ng build --configuration production",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "firebase:start": "firebase emulators:start",
    "update": "ng update --force @angular/cli @angular/core",
    "firebase:deploy": "firebase deploy",
    "release:patch": "standard-version --release-as patch",
    "release:minor": "standard-version --release-as minor",
    "release:major": "standard-version --release-as major"
  },
  "dependencies": {
    "@angular/animations": "^18.0.0",
    "@angular/common": "^18.0.0",
    "@angular/compiler": "^18.0.0",
    "@angular/core": "^18.0.0",
    "@angular/fire": "^18.0.1",
    "@angular/forms": "^18.0.0",
    "@angular/localize": "^18.0.0",
    "@angular/platform-browser": "^18.0.0",
    "@angular/platform-browser-dynamic": "^18.0.0",
    "@angular/router": "^18.0.0",
    "@fortawesome/angular-fontawesome": "^0.15.0",
    "@fortawesome/fontawesome-svg-core": "^6.5.2",
    "@fortawesome/free-brands-svg-icons": "^6.5.2",
    "@fortawesome/free-regular-svg-icons": "^6.5.2",
    "@fortawesome/free-solid-svg-icons": "^6.5.2",
    "@ng-bootstrap/ng-bootstrap": "^17.0.1",
    "@ngrx/store": "^18.0.1",
    "@popperjs/core": "^2.11.8",
    "@schematics/angular": "^18.0.1",
    "bootstrap": "^5.3.2",
    "core-js": "^3.37.1",
    "firebase": "^10.14.1",
    "inquirer-autocomplete-prompt": "^3.0.1",
    "luxon": "^3.4.4",
    "ngx-chips": "^3.0.0",
    "ngx-editor": "^18.0.0",
    "ngx-google-analytics": "^14.0.1",
    "ngx-toastr": "^18.0.0",
    "rxjs": "^7.8.1",
    "tslib": "^2.6.2",
    "zone.js": "~0.14.6"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.14",
    "@angular-eslint/builder": "19.2.0",
    "@angular-eslint/eslint-plugin": "19.2.0",
    "@angular-eslint/eslint-plugin-template": "19.2.0",
    "@angular-eslint/schematics": "19.2.0",
    "@angular-eslint/template-parser": "19.2.0",
    "@angular/cli": "^18.0.1",
    "@angular/compiler-cli": "^18.0.0",
    "@angular/language-service": "^18.0.0",
    "@types/jasmine": "~5.1.4",
    "@types/jasminewd2": "^2.0.13",
    "@types/luxon": "^3.4.2",
    "@types/node": "^20.11.19",
    "@typescript-eslint/eslint-plugin": "7.11.0",
    "@typescript-eslint/parser": "7.11.0",
    "bootstrap": "^4.6.1",
    "eslint": "8.57.0",
    "firebase-tools": "^13.31.2",
    "fs-web": "^1.0.1",
    "husky": "^9.0.11",
    "jasmine-core": "~5.1.2",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "^6.4.3",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-coverage-istanbul-reporter": "^3.0.3",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "lint-staged": "15.2.4",
    "os-browserify": "0.3.0",
    "path-browserify": "1.0.1",
    "standard-version": "^9.5.0",
    "ts-node": "^10.9.2",
    "typescript": "^5.4.5"
  }
}
